// Lead Movement authored copy and backend state codes; never customer content.
export const leadMovementArabicTranslations: Record<string, string> = {
  'Review historical evidence': 'مراجعة الدليل التاريخي',
  'Results changed. Review historical evidence again': 'تغيرت النتائج. راجع الدليل التاريخي مرة أخرى',
  'No leads require a new stage observation': 'لا يوجد عملاء يحتاجون ملاحظة حالة جديدة',
  'Some leads are unavailable within your current scope': 'بعض العملاء غير متاحين ضمن نطاق صلاحياتك الحالي',
  'Review historical evidence again before recording observations': 'راجع الدليل التاريخي مرة أخرى قبل تسجيل الملاحظات',
  'Evidence changed. Review historical evidence again': 'تغير الدليل. راجع الدليل التاريخي مرة أخرى',
  'Loading historical evidence…': 'جارٍ تحميل الدليل التاريخي…',
  'Historical evidence': 'الدليل التاريخي',
  'View source evidence': 'عرض دليل المصدر',
  'Source fields': 'حقول المصدر',
  'Source audit': 'سجل المصدر',
  'Stage observation': 'ملاحظة حالة المرحلة',
  'Observation time is not the original stage entry date. No leads will move.': 'وقت الملاحظة ليس تاريخ دخول المرحلة الأصلي. لن يتم نقل أي عميل.',
  'Historical sources reviewed; no stage entry date established': 'تمت مراجعة المصادر التاريخية ولم يثبت تاريخ دخول المرحلة',
  'Record {0} stage observations': 'تسجيل {0} ملاحظة حالة',
  '{0} stage observations recorded': 'تم تسجيل {0} ملاحظة حالة',
  '{0} leads reviewed · {1} source audit rows': 'تمت مراجعة {0} عميل · {1} سجل مصدر',
  'Requests Approval': 'مراجعة الطلبات',
  'Search leads': 'دوّر على عميل',
  'Name, phone or lead code': 'اسم العميل، رقمه أو كوده',
  'Lead Pool recipients are unavailable.': 'الموظفين المتاحين لاستلام العملاء مش متاحين دلوقتي.',
  'Eligible Lead Pool results are unavailable.': 'نتايج العملاء المؤهلين في المخزن مش متاحة دلوقتي.',
  'Eligible withdrawal results are unavailable.': 'نتايج العملاء المؤهلين للسحب مش متاحة دلوقتي.',
  'This movement option is unavailable.': 'خيار النقل ده مش متاح دلوقتي.',
  'Branches': 'الفروع',
  'Customer areas': 'مناطق العملاء',
  'All customer areas': 'كل مناطق العملاء',
  'Review saved customer areas: some values are no longer valid form areas. Clear or replace them before saving.': 'راجع المناطق المحفوظة: فيه قيم مش مناطق صحيحة من الفورم. امسحها أو اختار بدلها قبل الحفظ.',
  'Choose a customer area column, not an ID, contact time or study system.': 'اختار عمود منطقة العميل، مش رقم السجل أو معاد التواصل أو نظام الدراسة.',
  'Unable to load mapped branches': 'مش قادر يحمّل مناطق العملاء من الفورم.',
  'Apply date': 'تطبيق التاريخ',
  'Custom range': 'فترة مخصصة',
  'Selected range:': 'الفترة المختارة:',
  'Select date range': 'اختيار فترة التاريخ',
  'Date presets': 'فترات التاريخ',
  'Previous month': 'الشهر السابق',
  'Next month': 'الشهر التالي',
  'Close date filter': 'إغلاق فلتر التاريخ',
  'Clear date range': 'مسح فترة التاريخ',
  'Created date': 'تاريخ الإنشاء',
  'Last activity date': 'تاريخ آخر نشاط',
  'Search & Filters': 'البحث والفلاتر',
  'Next Step: Prepare Assignment': 'الخطوة التالية: تجهيز التوزيع',
  'Configure how the selected leads will be distributed.': 'حدد طريقة توزيع العملاء المختارين.',
  '{0} leads selected': 'تم اختيار {0} عميل',
  'leads could not be evaluated': 'عميل لم نتمكن من تقييم أهليتهم',
  'View unassessed leads': 'عرض العملاء المتعذّر تقييمهم',
  'Unassessed leads': 'عملاء تعذّر تقييم أهليتهم',
  '{0} leads could not be evaluated': '{0} عميل تعذّر تقييم أهليتهم',
  'Stage entry date not recorded': 'تاريخ دخول المرحلة غير مسجل',
  'No unassessed leads': 'لا يوجد عملاء متعذّر تقييم أهليتهم',
  'Previous unassessed leads': 'الصفحة السابقة من العملاء المتعذّر تقييمهم',
  'Next unassessed leads': 'الصفحة التالية من العملاء المتعذّر تقييمهم',
  'Unassessed withdrawal leads are unavailable.': 'قائمة العملاء المتعذّر تقييم أهليتهم للسحب غير متاحة.',
  'Stage entry date not recorded. These leads are not included in the eligible results.': 'تاريخ دخول المرحلة غير مسجل. هؤلاء العملاء غير مدرجين ضمن النتائج المؤهلة.',
  'Redistribute': 'إعادة التوزيع',
  'Departments': 'الأقسام',
  'Switch department': 'تغيير القسم',
  'Close departments': 'إغلاق الأقسام',
  'Current department': 'القسم الحالي',
  'Recently visited': 'الأقسام الأخيرة',
  'System departments': 'أقسام النظام',
  'Manager': 'الإدارة',
  'After-hours waiting': 'انتظار خارج ساعات العمل',
  'Hidden capacity waiting': 'انتظار السعة المتاحة',
  'Pending Transfer Requests': 'طلبات النقل المعلقة',
  'Pending New Lead Requests': 'طلبات العملاء الجدد المعلقة',
  'Never Opened': 'لم يتم فتح العميل',
  'No Answer > 7 Working Days': 'بدون رد لأكثر من 7 أيام عمل',
  'New Queue': 'قائمة العملاء الجدد',
  'Hidden Queue': 'قائمة الانتظار المخفية',
  'Balance New leads': 'موازنة العملاء الجدد',
  'Released by capacity': 'إتاحة حسب السعة',
  'Review / Transfer': 'مراجعة / نقل',
  'Approve / Reject': 'موافقة / رفض',
  'All dates': 'كل التواريخ',
  'Last 7 days': 'آخر 7 أيام',
  'Last 14 days': 'آخر 14 يوم',
  'Last 28 days': 'آخر 28 يوم',
  'Last 30 days': 'آخر 30 يوم',
  'Follow Up': 'متابعة',
  'Distribute from pool': 'توزيع من المخزن',
  'Direct rotation': 'نقل مباشر',
  'Select first': 'اختيار أول',
  'Select the first {0} {1}': 'اختيار أول {0} {1}',
  '{0} selected': 'تم اختيار {0}',
  '{0} / {1} allocated': 'تم تخصيص {0} من {1}',
  '{0} remaining': 'متبقي {0}',
  '{0} over selected total': '{0} أكثر من العدد المختار',
  'Enter a whole number from 1 to 5,000.': 'أدخل عددًا صحيحًا من 1 إلى 5,000.',
  'No active sales recipients are available.': 'لا يوجد موظفو مبيعات نشطون متاحون للاستلام.',
  'Selected recipients are no longer available.': 'الموظفون المختارون لم يعودوا متاحين للاستلام.',
  'Unable to load recipients.': 'تعذر تحميل الموظفين المستلمين.',
  'Unable to load data': 'تعذر تحميل البيانات',
  'Backend update required: Lead Pool recipients are unavailable.': 'تحديث السيرفر مطلوب: مستلمو مخزن العملاء غير متاحين.',
  'Backend update required: eligible Lead Pool results are unavailable.': 'تحديث السيرفر مطلوب: نتائج مخزن العملاء المؤهلة غير متاحة.',
  'Backend update required: eligible withdrawal results are unavailable.': 'تحديث السيرفر مطلوب: نتائج السحب المؤهلة غير متاحة.',
  'No matching leads.': 'لا يوجد عملاء مطابقون.',
  'Filters changed': 'تم تغيير الفلاتر',
  'Loading results…': 'جاري تحميل النتائج…',
  'Previewing…': 'جاري المعاينة…',
  'Lead selection': 'اختيار العملاء',
  'With previous history': 'بالسجل السابق',
  'Without previous history': 'بدون السجل السابق',
  'Inactive owner': 'موظف مسؤول غير نشط',
  'Missing recipient data': 'بيانات الموظف المستلم غير متاحة',
  'Missing specialization data': 'بيانات تخصص الموظف غير متاحة',
  'Missing capacity data': 'بيانات السعة غير متاحة',
  'Protected leads cannot move': 'لا يمكن نقل العملاء المحميين',
  'Payment pending': 'دفع قيد الانتظار',
  'Upcoming follow-up': 'متابعة قادمة',
  'Manual lock': 'قفل يدوي',
  'Transfer in progress': 'عملية نقل جارية',
  'Recorded payment or active enrollment': 'دفع مسجل أو تسجيل فعال',
  'Active booking or registration': 'حجز أو تسجيل فعال',
  'and {0} more': 'و{0} آخرين',
  'Select active sales recipients': 'اختر موظفي مبيعات نشطين للاستلام',
  'Selection changed; refresh and preview again': 'تغير الاختيار؛ حدّث النتائج وأعد المعاينة',
  'The selected leads changed. Preview again before confirming': 'تغيرت بيانات العملاء المختارين. أعد المعاينة قبل التأكيد',
  'Custom quantities must equal the selected lead count': 'يجب أن يساوي مجموع الكميات عدد العملاء المختارين',
  'Reason must contain at least three letters or numbers': 'يجب أن يحتوي السبب على ثلاثة أحرف أو أرقام على الأقل',
  'No selected recipient is assigned to {0} for lead #{1}': 'لا يوجد مستلم مختار مرتبط بكورس {0} للعميل #{1}',
  'Course not recorded for lead #{0}; review the lead before assignment': 'الكورس غير مسجل للعميل #{0}؛ راجع بياناته قبل التوزيع',
  'Warehouse membership changed': 'تغيرت عضوية العملاء في المخزن',
  'Movement request failed': 'تعذر تنفيذ طلب نقل العملاء',
  'Rollback blocked': 'التراجع غير مسموح',
  'Rollback is not supported for this operation type': 'التراجع غير متاح لهذا النوع من العمليات',
  'Forbidden': 'ليس لديك صلاحية لهذا الإجراء',
  'Sales Manager or General Manager permission required': 'هذا الإجراء يحتاج صلاحية مدير المبيعات أو المدير العام',
  'A reason is required to confirm this operation': 'يجب إدخال سبب قبل تأكيد العملية',
  'Preview again before confirming; the preview is missing or expired': 'أعد المعاينة قبل التأكيد؛ المعاينة غير موجودة أو انتهت صلاحيتها',
  'Invalid movement filters': 'فلاتر نقل العملاء غير صالحة',
  'Original entry dates must use YYYY-MM-DD format': 'يجب إدخال تاريخ الدخول الأصلي بصيغة YYYY-MM-DD',
  'Original entry month must use YYYY-MM format': 'يجب إدخال شهر الدخول الأصلي بصيغة YYYY-MM',
  'Choose one original entry date mode': 'اختر طريقة واحدة لتحديد تاريخ الدخول الأصلي',
  'entry_date_from must be on or before entry_date_to': 'تاريخ البداية يجب أن يسبق تاريخ النهاية أو يساويه',
  'Custom quantities must include every selected recipient': 'يجب تحديد الكمية لكل موظف مختار',
  'Custom quantities cannot be negative': 'الكميات المخصصة لا يمكن أن تكون سالبة',
  'Custom quantities require custom distribution': 'الكميات المخصصة تتطلب اختيار التوزيع المخصص',
  'Custom quantities cannot satisfy course eligibility for lead #{0}': 'الكميات المخصصة لا تحقق أهلية الكورس للعميل #{0}',
  'Warehouse membership changed; preview again': 'تغيرت عضوية العملاء في المخزن؛ أعد المعاينة',
  'Movement batch not found': 'عملية النقل غير موجودة',
  'Manager approval required': 'موافقة المدير مطلوبة',
  'Recommendation not found': 'الاقتراح غير موجود',
  'Already reviewed': 'تمت مراجعة هذا الاقتراح بالفعل',
  'Choose a target employee': 'اختر الموظف المستلم',
  'Selection contains leads outside your team': 'الاختيار يحتوي على عملاء خارج فريقك',
  'Override is disabled': 'تجاوز الحماية غير مفعّل',
  'The connected backend does not support this movement option. Update the backend before retrying.': 'السيرفر الحالي لا يدعم خيار النقل هذا. يجب تحديث السيرفر قبل المحاولة مجددًا.',
  'Recipient inactive': 'الموظف المستلم غير نشط',
  'Course not assigned': 'الكورس غير مسند للموظف',
  'Capacity full': 'السعة مكتملة',
  'Course not recorded': 'الكورس غير مسجل',
  'Outside employment': 'خارج فترة العمل',
  'Outside shift or missing schedule': 'خارج الشيفت أو جدول العمل غير مسجل',
};

export const leadMovementEnglishTranslations: Record<string, string> = {
  'Unable to load mapped branches': 'Unable to load customer areas from the form.',
  'Backend update required: Lead Pool recipients are unavailable.': 'Lead Pool recipients are unavailable.',
  'Backend update required: eligible Lead Pool results are unavailable.': 'Eligible Lead Pool results are unavailable.',
  'Backend update required: eligible withdrawal results are unavailable.': 'Eligible withdrawal results are unavailable.',
  'The connected backend does not support this movement option. Update the backend before retrying.': 'This movement option is unavailable.',
  complete: 'Completed',
  recipient_data_missing: 'Missing recipient data',
  specialization_data_missing: 'Missing specialization data',
  capacity_data_missing: 'Missing capacity data',
  'payment pending': 'Payment pending',
  'upcoming follow up': 'Upcoming follow-up',
  'manual lock': 'Manual lock',
  'batch in progress': 'Transfer in progress',
  'recorded payment or active enrollment': 'Recorded payment or active enrollment',
  'active booking or registration': 'Active booking or registration',
  'inactive target': 'Recipient inactive',
  'course not assigned': 'Course not assigned',
  'capacity full': 'Capacity full',
  'course missing': 'Course not recorded',
  'outside employment': 'Outside employment',
  'outside shift or missing schedule': 'Outside shift or missing schedule',
};
